module.exports = __webpack_public_path__ + "img/int4.80ccb4ce.jpg";